export const gallery = [
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/49d7db0a-4694-4ca9-b1fe-cd692665c5b7.jpg',
    alt: 'Freshly painted living room with white walls and a navy accent wall',
    label: 'Interior repaint'
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/b8806321-937e-4e08-9e2a-7c8a383a0341.jpg',
    alt: 'Repainted house exterior with gray siding, white trim and a navy front door',
    label: 'Exterior refresh'
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/0d603a4e-68c6-4fd9-ab55-fcc0ffc8728d.jpg',
    alt: 'Painter rolling paint onto an interior wall with taped trim and drop cloths',
    label: 'Prep done right'
  }
]
